export enum ExhibitorType {
  NACAC = "nacac",
  SCHOOL = "school",
}

export enum SchoolLevel {
  BACHELORS = "four_years",
  ASSOCIATES = "two_to_four_years,less_than_two_years",
}

export enum SchoolControl {
  PUBLIC = "public",
  PRIVATE = "private",
}

export enum SchoolSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export const exhibitorTypeOptions = [
  {
    value: ExhibitorType.NACAC,
    label: "College Advising Center",
    defaultValue: false,
  },
  {
    value: ExhibitorType.SCHOOL,
    label: "College and University Exhibitors",
    defaultValue: false,
  },
]

export const schoolLevelOptions = [
  { value: SchoolLevel.BACHELORS, label: "Bachelors", defaultValue: false },
  {
    value: SchoolLevel.ASSOCIATES,
    label: "Associates",
    defaultValue: false,
  },
]

export const schoolControlOptions = [
  { value: SchoolControl.PRIVATE, label: "Private", defaultValue: false },
  { value: SchoolControl.PUBLIC, label: "Public", defaultValue: false },
]

export const schoolSizeOptions = [
  {
    value: SchoolSize.SMALL,
    label: "Small (less than 5,000 students)",
    defaultValue: false,
  },
  {
    value: SchoolSize.MEDIUM,
    label: "Medium (5,000 - 20,000 students)",
    defaultValue: false,
  },
  {
    value: SchoolSize.LARGE,
    label: "Large (over 20,000 students)",
    defaultValue: false,
  },
]
